import { type FC } from "react";
import { Alert } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useComplianceRecordsQuery } from "@/partner/entities/compliance";
import { useComplianceEnabled } from "../model";

interface ComplianceWarningProps {
  contentId?: string | null;
  productId?: string | null;
  /** Опубликован ли тайтл: у черновика записей может ещё не быть. */
  published: boolean;
}

/**
 * Предупреждение «у опубликованного тайтла нет записей 2257». Публикацию
 * не блокирует (требование спеки §4), только подсвечивает.
 */
export const ComplianceWarning: FC<ComplianceWarningProps> = ({
  contentId,
  productId,
  published,
}) => {
  const { t } = useTranslation();
  const enabled = useComplianceEnabled();

  const { data } = useComplianceRecordsQuery({
    variables: { contentId: contentId ?? null, productId: productId ?? null },
    skip: !enabled || !published || (!contentId && !productId),
  });

  if (!enabled || !published) return null;
  if (!data) return null;
  if (data.complianceRecords.length > 0) return null;

  return <Alert severity="warning">{t("compliance.warning")}</Alert>;
};
